const Environment = () => {
  var isLocalhost = Boolean(
    window.location.hostname === "localhost" ||
      window.location.hostname === "[::1]" ||
      window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
      )
  );

  var isQA = Boolean(
    window.location.href.match("source-qa") || window.location.href.match("qa.")
  );

  var isSource = Boolean(window.location.href.match("source-"));

  return {
    isLocalhost: isLocalhost,
    isQA: isQA,
    isSource: isSource,
  };
};

export { Environment };
